import FetchHelper from './OldFetchHelper';
import config from '../../config';
import OldErrorHandlerHelper from './OldErrorHandlerHelper';
import OldSessionStorageHelper from './OldSessionStorageHelper';

class CurrencyHelper {
  async fetchCurrencies() {
    if(this.currencies) return this.currencies;

    this.currencies = OldSessionStorageHelper.getCurrencyList();

    if(!this.currencies) {
      const fetchConfig = {
        path: `${config.api.paths.configs.basepath}${config.api.paths.configs.paths.currencies}`,
      };

      const fetchResult = await FetchHelper.get(fetchConfig);

      if(fetchResult && fetchResult.success) {
        this.currencies = fetchResult.data;
        OldSessionStorageHelper.setCurrencyList(this.currencies);
      } else {
        OldErrorHandlerHelper.handleError(fetchResult, { logToConsole: true });
      }
    }

    if(!this.currencies) {
      return [];
    }

    return this.currencies;
  }
}

export default new CurrencyHelper();
